export const getLatestNews = (data, volume) => {
  return data?.slice(0, volume);
};

export const getTrendingNews = (data) => {
  if (!data) return;
  const trending = data
    .filter((eachNews) => {
      return eachNews?.views >= 3;
    })
    .slice(0, 5);
  return trending;
};

export const getPopularNews = (data) => {
  const popular = data
    .filter((eachNews) => {
      return eachNews?.is_breaking;
    })
    .slice(0, 5);
  return popular;
};

export const featuredNews = (data, volume) => {
  const featuredNews = data
    .filter((eachNews) => {
      return eachNews?.is_featured;
    })
    .slice(0, volume);

  return featuredNews;
};

export const technologyNews = (data, volume) => {
  const techNews = data
    ?.filter((eachNews) => {
      return eachNews?.category_names === "Technology";
    })
    .slice(0, volume);
  return techNews;
};

export const politicalNews = (data, volume) => {
  const techNews = data
    ?.filter((eachNews) => {
      return eachNews?.category_names === "Politics";
    })
    .slice(0, volume);
  return techNews;
};

export const businessNews = (data, volume) => {
  const techNews = data
    ?.filter((eachNews) => {
      return eachNews?.category_names === "Business";
    })
    .slice(0, volume);
  return techNews;
};

export const entertainmentNews = (data, volume) => {
  const techNews = data
    ?.filter((eachNews) => {
      return eachNews?.category_names === "Entertainment";
    })
    .slice(0, volume);
  return techNews;
};

export const handleTitleClick = (slug) => {
  window.open(`https://essentialnews.ng/post/${slug}`, "_blank");
};
